import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaArticle } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the encyclopedia article from the CMS for the given slug
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaArticle | undefined>}
 */
const getEncyclopediaArticleBySlug = async (
  slug: string,
  locale: Language = Language.DUTCH
): Promise<CmsEncyclopediaArticle | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaArticle>>(
      `${process.env.CMS_API_URL}/encyclopedia-article/${slug}?${query}`
    )

    return data.data
  } catch (_) {
    return undefined
  }
}

export default getEncyclopediaArticleBySlug
